import React from 'react'

/**
 * LegendBottomIcon - simple low bar icon to indicate bottom legend mode
 */
export const LegendBottomIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Legend Bottom" {...props}>
    <rect x="3" y="4" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <rect x="3" y="18" width="18" height="2" rx="1" fill="currentColor" />
  </svg>
)

export default LegendBottomIcon

